var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-header',{attrs:{"pageTitle":_vm.pageTitle,"backTo":_vm.backTo}}),_vm._v(" "),_c('div',{staticClass:"flex-column"},[_c('router-view',{staticStyle:{"flex":"1"}}),_vm._v(" "),_c('copyright')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ffa017","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/TitleLayout.vue
// module id = null
// module chunks = 